var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsAddNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_add_new",
    transform: "translate(0 -0.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons_add_new-2",
    "data-name": "icons_add_new",
    d: "M47.959,64.5a3.677,3.677,0,1,1-7.354,0V47.953H24.061a3.677,3.677,0,0,1,0-7.354H40.606V24.054a3.677,3.677,0,0,1,7.354,0V40.6H64.5a3.677,3.677,0,0,1,0,7.354H47.959ZM9.443,44.276A34.842,34.842,0,0,1,37.86,10.048l3-.562V1.917l-4.35.809a42.268,42.268,0,0,0,0,83.1l4.35.809V79.065l-3-.562A34.842,34.842,0,0,1,9.443,44.276ZM52.055,2.727l-4.349-.809V9.487l3,.562a34.822,34.822,0,0,1,0,68.455l-3,.562v7.569l4.349-.809a42.266,42.266,0,0,0,0-83.1Z",
    transform: "translate(-0.036 -0.417)",
    fill: "#3d464c",
    opacity: 0.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bounding",
    width: 89,
    height: 89,
    transform: "translate(0 0.231)",
    fill: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAddNew);
export default __webpack_public_path__ + "static/media/icons_add_new.4ef70105.svg";
export { ForwardRef as ReactComponent };